import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Register from '../components/Register';
 import Login from '../components/Login';
 import Layout from '../components/Layout';
// import Editor from '../components/Editor';
// import Admin from '../components/Admin';
// import Missing from '../components/Missing';
// import Unauthorized from '../components/Unauthorized';
// import Lounge from '../components/Lounge';
// import LinkPage from '../components/LinkPage';
// import RequireAuth from '../components/RequireAuth';
// import PersistLogin from '../components/PersistLogin';
// import Empleados from '../components/Empleados';
// import Faltas from '../components/Faltas';
// import Vacaciones from '../components/Vacaciones';
 import useAuth from '../hooks/useAuth';
// import ListadoFaltas from '../components/ListadoFaltas';
// import ListadoVacaciones from '../components/ListadoVacaciones';
// import CapturaExcepciones from '../components/CapturaExcepciones';
// import ListadoExcepciones from '../components/ListadoExcepciones';
import RequireAuth from '../components/RequireAuth';
import PersistLogin from '../components/PersistLogin';
import Home from '../components/Home';
import Empresas  from '../components/Empresas';
import Confronta  from '../components/Confronta';
import Cfdis  from '../components/Cfdis';
import ResultadosConfronta from '../components/ResultadosConfronta';
import ResultadosCFDIs from '../components/ResultadosCFDIs';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AdminShell from '../components/AdminShell';
import Dashboard from '../components/Dashboard';
import Settings from '../components/Settings';
import Users from '../components/Users';
import PerfilUsuario from '../components/PerfilUsuario';

const ROLES = {
    'User': 2001,
    'Editor': 1984,
    'Admin': 5150
  }
export function MyRoutes() {
const navigate = useNavigate();
    const location = useLocation();
  const { auth } = useAuth();
console.log(auth);
localStorage.setItem("usuario", JSON.stringify(auth.user));

if (['/login', '/register', '/forgot-password'].includes(location.pathname)) {
  document.body.classList.add('login-page');
} else {
  document.body.classList.remove('login-page');
}

 // const MyRoutes = () => {
  return (
    <>
    <Routes>
      {/* <Route path="/" element={<Layout />}> */}
        {/* public routes */}
        <Route path="login" element={<Login />} />
        <Route element={<PersistLogin />}> 
        <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
         <Route path="/" element={<Layout Auth={auth} />}>
         <Route index element={<Confronta Auth={auth}/>} />
          <Route path="confronta">
            <Route index element={<Confronta Auth={auth}/>} />                
            <Route path="resultados" element={<ResultadosConfronta Auth={auth}/>} />
          </Route>
          <Route path="cfdis">
            <Route index element={<Cfdis Auth={auth}/>} />
            <Route path="resultados" element={<ResultadosCFDIs Auth={auth}/>} />
          </Route>
          <Route path="/perfil" element={<PerfilUsuario  Auth={auth}/>} />
          {/* <Route
                path="Confronta"
                element={<Confronta Auth={auth} />}
              /> */}
         </Route>
         
            {/* <Route path="/" element={<Home  Authentication={auth}  />} /> */}
            <Route path="/empresas" element={<Empresas  Authentication={auth}/>} />
            <Route path="/regpatronales" element={<Empresas  Authentication={auth}/>} />
            <Route path="/afiliados" element={<Empresas  Authentication={auth}/>} />
            <Route path="/bimestres" element={<Empresas  Authentication={auth}/>} />
            {/* <Route path="/Confronta" element={<Confronta  Authentication={auth}/>} /> */}
            <Route path="/resultadosConfronta" element={<ResultadosConfronta  Authentication={auth}/>} />
          </Route>          
        </Route>
        
        {/* <Route path="register/0103" element={<Register />} />        
        <Route path="unauthorized" element={<Unauthorized />} /> */}

        {/* catch all */}
        {/* <Route path="*" element={<Missing />} /> */}
      
      {/* </Route> */}
    </Routes>
    <Routes>
    {/* <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>  */}
    <Route path="/admin" element={<AdminShell />}>
         <Route index element={<Dashboard />} /> 
         <Route path="usuarios" element={<Users />} />
        <Route path="ajustes" element={<Settings />} /> 
      </Route>
    {/* </Route> */}
    
    </Routes>
    </>
    
  )
}

//export default MyRoutes